import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { LandingPageData } from 'store/landing/types';

export type Recommendation = AppBundle.Api.Entity.Design.V1.ISimilarProduct & {
  initialPrice?: {
    value: number;
    currency: string;
    formatted: string;
  };
  finalPrice?: {
    value: number;
    currency: string;
    formatted: string;
  };
};

export type LandingState = {
  categoryId: number | null;
  data: LandingPageData | null;
};

export const landingInitialState: LandingState = {
  categoryId: null,
  data: null,
};

export const slice = createSlice({
  name: 'landing',
  initialState: landingInitialState,
  reducers: {
    setLandingPageData: (state, action: PayloadAction<LandingPageData | null>) => {
      state.data = action.payload;
    },
    setLandingPageCategoryId: (state, action: PayloadAction<number>) => {
      state.categoryId = action.payload;
    },
  },
});

export const { setLandingPageData, setLandingPageCategoryId } = slice.actions;
const { reducer } = slice;
export default reducer;
